import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Wrench, CheckCircle } from 'lucide-react';

const PeriodicService = () => {
  const navigate = useNavigate();
  const [make, setMake] = useState('Maruti');
  const [model, setModel] = useState('Swift');

  const makeList = ['Maruti', 'Hyundai', 'Honda', 'Tata', 'Toyota'];
  const modelListByMake = {
    Maruti: ['Swift', 'Baleno', 'Brezza'],
    Hyundai: ['i20', 'Creta', 'Venue'],
    Honda: ['City', 'Amaze', 'Elevate'],
    Tata: ['Punch', 'Nexon', 'Altroz'],
    Toyota: ['Glanza', 'Hyryder', 'Innova'],
  };

  const packages = [
    {
      title: 'Basic Service',
      points: 100,
      frequency: 'Every 10,000 km',
      items: ['Engine Oil Change', 'Oil Filter Replacement', 'Air Filter Cleaning', 'Basic Inspection', 'Tyre Pressure Check', 'Battery Check'],
    },
    {
      title: 'Standard Service',
      points: 200,
      frequency: 'Every 15,000 km',
      items: ['All Basic Service Items', 'Brake Fluid Check', 'Coolant Top-up', 'Spark Plug Cleaning', 'AC Filter Cleaning', 'Wheel Alignment'],
    },
    {
      title: 'Premium Service',
      points: 300,
      frequency: 'Every 20,000 km',
      items: ['All Standard Service Items', 'Transmission Fluid Change', 'Fuel System Cleaning', 'Timing Belt Check', 'Suspension Check', 'Complete System Diagnostics'],
    },
  ];

  React.useEffect(() => {
    if (!modelListByMake[make]?.includes(model)) {
      setModel(modelListByMake[make]?.[0] || '');
    }
  }, [make]);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center space-x-4">
        <button
          onClick={() => navigate('/customer/services')}
          className="p-2 hover:bg-gray-100 rounded-lg"
        >
          <ArrowLeft size={24} className="text-gray-700" />
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Periodic Service (On-site)</h1>
          <p className="text-gray-600 mt-1">Select your car to view on-site packages</p>
        </div>
      </div>

      {/* Car Selection */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Car Make</label>
            <div className="flex flex-wrap gap-2">
              {makeList.map((m) => (
                <button
                  key={m}
                  onClick={() => setMake(m)}
                  className={`px-4 py-2 rounded-full border transition ${
                    make === m
                      ? 'bg-primary-500 text-white border-primary-500'
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  {m}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Car Model</label>
            <div className="flex flex-wrap gap-2">
              {(modelListByMake[make] || []).map((md) => (
                <button
                  key={md}
                  onClick={() => setModel(md)}
                  className={`px-4 py-2 rounded-full border transition ${
                    model === md
                      ? 'bg-primary-500 text-white border-primary-500'
                      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
                >
                  {md}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Service Packages */}
      <div className="space-y-4">
        {packages.map((pkg, index) => (
          <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center space-x-3">
                <Wrench size={20} className="text-primary-600" />
                <h3 className="text-lg font-bold text-gray-900">{pkg.title}</h3>
              </div>
              <span className="px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-sm font-medium">
                {pkg.points} Points
              </span>
            </div>
            <p className="text-sm text-gray-600 mb-4">{pkg.frequency}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
              {pkg.items.map((item, idx) => (
                <div key={idx} className="flex items-center space-x-2">
                  <CheckCircle size={16} className="text-green-600 flex-shrink-0" />
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
            <button
              onClick={() => navigate('/customer/services')}
              className="w-full px-4 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600"
            >
              Back to Services
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PeriodicService;

